import cn from 'classnames';
import Image from 'next/image';
import { Link } from 'src/components/Link';

import s from './MlSpaceArticleSlide.module.scss';

interface MlSpaceArticleSlideProps {
  title: string;
  link: string;
  image: string;
}

export function MlSpaceArticleSlide({
  title,
  link,
  image,
}: MlSpaceArticleSlideProps) {
  return (
    <Link
      href={link}
      className={cn(s.root, 'link')}
      id={`mlspace-article-link-${title}`}
      analyticsOptions={{
        action: link,
        clickZone: 'body',
        clickElement: 'cardclick',
        clickContent: title,
        uniqueId: `mlspace-article-link-${title}`,
        transitionType: 'inside-link',
        clickZoneCategory: 'site-body',
        transitionUrl: link,
        transitionTypeMetrics: 'internal',
      }}
    >
      <div className={s.imgWrapper}>
        <Image
          className={s.img}
          src={image}
          alt={title}
          data-qa="slide image"
          width={383}
          height={289}
        />
      </div>
      <span className={s.title}>{title}</span>
    </Link>
  );
}
